import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PlukingChecklistReport } from './Pages/listing';

export const PlukingChecklistReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PlukingChecklistReport} />
    </Fragment>
)